import { render, staticRenderFns } from "./StatusMessageDetail.vue?vue&type=template&id=2136b2fb&scoped=true"
import script from "./StatusMessageDetail.vue?vue&type=script&lang=js"
export * from "./StatusMessageDetail.vue?vue&type=script&lang=js"
import style0 from "./StatusMessageDetail.vue?vue&type=style&index=0&id=2136b2fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2136b2fb",
  null
  
)

export default component.exports